import { jwpPlayerId } from '../constants';
import domWrap from '../utils/domWrap';
import h from '../utils/htm';
import http from '../utils/http';
import playerTrack from '../utils/playerTrack';

let activeModalPlayer;

export default async body => { // 'body'
	
	domWrap(body).on('click','comp-resources a[type="VID"], comp-feature > comp-container[jwpid]:not(comp-container[jwpid="+"]), super-video [jwpid]:not([jwpid="+"]), a[href*="#jwpid"]',async function(event){
		const loc = location.href;
		let jwpid = this.getAttribute('jwpid'),
			href = this.getAttribute('href') || '';

		if(this.matches('[href*="#jwpid"]')) {
			let urlParts = href.split('#jwpid=');
			href = urlParts[0];
			jwpid = urlParts[1];
		}

		if(jwpid.substr(0,1) === '+'){
			jwpid = jwpid.substr(1);
		}

		if(window.outerWidth > 768 || (this.tagName !== 'A' && jwpid)){
			event.preventDefault();
			const 	{default: jwp} = await import('../libs/jwplayerMod'),
					{default: lightbox} = await import('../utils/lightbox');

			lightbox(
				h('div class="vid-holder"',
					h('div')(href ? 'span actions' : '',
						h('a href="'+href+'" target="_blank" class="download" download','Download')
						('a href="mailto:?subject=Detroit Video&body=Video URL: '+ encodeURIComponent('https://'+href.split('//').pop())+'" class="email" target="mailto-target" email','Email')
					)
					('iframe name="mailto-target"')
				),() => {
					activeModalPlayer = jwp(document.querySelector('#modal-lightbox .vid-holder > div'));

					http('https://content.jwplatform.com/feeds/' + jwpid + '.json').get()
						.then(data => {
							activeModalPlayer.setup({
								width: 560,
								height: 315,
								autostart: true,
								pid:jwpPlayerId,
								playlist: data.playlist
							});
							playerTrack(activeModalPlayer);
							if(this.getAttribute('assetid')){
								history.replaceState({}, "Video", "/video/"+this.getAttribute('assetid'));
							}
						})
						.catch(()=>{});
				},() => {
					try{
						activeModalPlayer.remove();
					} catch(e) {}
					
					// Pop History
					history.replaceState({}, document.title, loc);
				});
		}
	});
};